
//export const API_HOST = 'https://7czrqskmb4.execute-api.eu-west-1.amazonaws.com/dev' //process.env.REACT_APP_API_HOST ||'http://localhost:3001'
export const API_HOST = process.env.REACT_APP_API_HOST ||'http://localhost:3001'

 export default { 
    region: 'eu-west-1', 
    identityPoolId: 'eu-west-1:7696a776-5f5d-4922-a8b2-9646d98a8ee3', 
    userPoolId: 'eu-west-1_DwxrzNjfi', 
    clientId: 'e3g6m1i7sahh476mn42jli25s',
    bucket: 'bt-profile-image-test',
};


// WEBPACK FOOTER //
// ./src/config.js